import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import * as _ from "lodash";
import * as messageBox from "./MessageBox";
import MessageBox from "./MessageBox";
import * as React from "react";
import * as mui from "material-ui";
import { bindStr, TranslatorFunction, IDS } from "i18n/util";
import IconClose from "material-ui/svg-icons/content/clear";



class UiHelpers {

    DESKTOP_WIDTH = 980;
    TABLET_WIDTH = 500;

    @observable messageBoxProps?: messageBox.IPropsBase;
    @observable __: TranslatorFunction;

    resizeListenerAdded = false;
    @observable windowWidth = 0;
    @observable windowHeight = 0;

    @observable snackbarProps?: {
        message: string;
        durationInMs: number;
        onClose: () => void;
    };

    @computed get isMobile() {
        return this.windowWidth && (this.windowWidth < this.TABLET_WIDTH);
    }

    @computed get isDesktop() {
        return !this.isMobile;
    }

    onResize = () => {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName("body")[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;

        this.windowWidth = x;
        this.windowHeight = y;
    }

    /**
     * Add this in componentDidMount of your outmost container component
     */
    addResizeListener() {
        if (!this.resizeListenerAdded) {
            window.addEventListener("resize", this.onResize);
            this.onResize();
            this.resizeListenerAdded = true;
        }
    }

    /**
     * Add this in componentWillUnmount of your outmost container component
     */
    removeResizeListener() {
        if (this.resizeListenerAdded) {
            window.removeEventListener("resize", this.onResize);
            this.resizeListenerAdded = false;
        }
    }


    @action showGenericError(error: number) {
        if (this.__) {
            this.showMessageBox({
                title: this.__("error"),
                message: this.__("error.genericMessage", { errorCode: error })
            });
        }
    }


    @action showMessageBox = (props: messageBox.IPropsBase) => {
        this.messageBoxProps = props;

        // Always hide after action
        if (props.onOk) {
            this.messageBoxProps.onOk = (event: any) => {
                props.onOk();
                this.hideMessageBox(event);
            };
        }

        if (props.onCancel) {
            this.messageBoxProps.onCancel = (event: any) => {
                props.onCancel();
                this.hideMessageBox(event);
            };
        }

        // Only message -> do default ok + hideMessageBox        
        if (!props.onOk && !props.onCancel) {
            this.messageBoxProps.onOk = this.hideMessageBox;
        }
    }

    @action hideMessageBox = (event: any) => {
        // Do not propagate click
        if (event) {
            event.preventDefault();
        }
        this.messageBoxProps = undefined;
    }


    @action showSnackbar = (message: string, durationInMs = 4000, onClose?: any) => {
        this.snackbarProps = {
            message: message,
            durationInMs: durationInMs,
            onClose: () => {
                this.snackbarProps = undefined;
                if (onClose) {
                    onClose();
                }
            }
        };
    }


    renderSmallButton(params: {
        icon: React.ComponentClass<{}>;
        onClick?: () => void;
        size?: number;
        color?: string;
        marginTop?: number | string;
        marginLeft?: number | string;
        marginRight?: number | string;
    }) {
        const ICON_SIZE = params.size ? params.size : 28;
        const smallIconStyles = {
            smallIcon: { width: ICON_SIZE, height: ICON_SIZE, color: params.color ? params.color : "black" },
            small: {
                width: ICON_SIZE,
                height: ICON_SIZE,
                padding: 0,
                marginTop: params.marginTop ? params.marginTop : 0,
                marginLeft: params.marginLeft ? params.marginLeft : 0,
                marginRight: params.marginRight ? params.marginRight : 0,
            },
        };

        return (
            <mui.IconButton
                iconStyle={smallIconStyles.smallIcon}
                style={smallIconStyles.small}
                onClick={params.onClick}
            >
                {React.createElement(params.icon)}
            </mui.IconButton>
        );
    }


    renderCloseButton(closeUrl: string) {
        return (
            <a
                href={closeUrl}
                style={{
                    position: "absolute",
                    right: 10,
                    top: 10
                }}
            >
                <IconClose />
            </a>
        );
    }

    renderMessageBox() {
        return this.messageBoxProps ? (
            <MessageBox
                title={this.messageBoxProps.title}
                message={this.messageBoxProps.message}
                labelOk={this.messageBoxProps.labelOk}
                labelCancel={this.messageBoxProps.labelCancel}
                onOk={this.messageBoxProps.onOk}
                onCancel={this.messageBoxProps.onCancel}
                open={true}
            />
        ) : null;
    }

    renderSnackbar() {
        return this.snackbarProps ? (
            <mui.Snackbar
                open={this.snackbarProps !== null}
                message={this.snackbarProps.message}
                autoHideDuration={this.snackbarProps.durationInMs}
                onRequestClose={this.snackbarProps.onClose}
            />) : (
                <mui.Snackbar
                    open={false}
                    message={""}
                />
            );
    }
}

export const ui = new UiHelpers();


export const Desktop = observer((props: any) => {
    return ui.isDesktop ? <div>{...props.children}</div> : null;
});


export const Mobile = observer((props: any) => {
    return ui.isMobile ? <div>{...props.children}</div> : null;
});





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/uiHelpers.tsx